import { render, staticRenderFns } from "./ServiceProposalHistory.vue?vue&type=template&id=055d540e&scoped=true"
import script from "./ServiceProposalHistory.vue?vue&type=script&lang=js"
export * from "./ServiceProposalHistory.vue?vue&type=script&lang=js"
import style0 from "./ServiceProposalHistory.vue?vue&type=style&index=0&id=055d540e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055d540e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('055d540e')) {
      api.createRecord('055d540e', component.options)
    } else {
      api.reload('055d540e', component.options)
    }
    module.hot.accept("./ServiceProposalHistory.vue?vue&type=template&id=055d540e&scoped=true", function () {
      api.rerender('055d540e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/provider/proposalHistory/ServiceProposalHistory.vue"
export default component.exports